import * as React from 'react';

import { useProgramJoinMutation } from 'bundles/enterprise-legacy-learner-home/queryHooks/useProgramJoinMutation';
import { useEnterpriseProductFeatures } from 'bundles/unified-common/contexts/EnterpriseProductFeaturesContext';
import { useProgram, useProgramMembership } from 'bundles/unified-common/contexts/EnterpriseProgramContext';

export const useProgramAutoJoinDomainAllowList = () => {
  const program = useProgram();
  const features = useEnterpriseProductFeatures();
  const { membership, isMembershipLoading } = useProgramMembership();
  const { programJoinMutation } = useProgramJoinMutation();
  const enableProgramAutoJoin = features?.enableProgramAutoJoin ?? false;
  const [autoJoinSettled, setAutoJoinSettled] = React.useState(false);
  const autoJoinStartedRef = React.useRef(false);
  React.useEffect(() => {
    if (
      !enableProgramAutoJoin ||
      isMembershipLoading ||
      autoJoinStartedRef.current ||
      !program?.id ||
      !membership?.isAllowlisted
    ) {
      return;
    }
    autoJoinStartedRef.current = true;
    const programId = program.id;

    // Fire the domain-allowlist program join, then redirect once the API responds (handled in the redirect
    // block below). IMPORTANT: we redirect to org home regardless of success or failure — a failed join
    // (capacity / no seats, unverified email, network/server error) must NOT trap the learner on the program
    // page. The org-home experience handles any post-redirect state.
    const runAutoJoin = async () => {
      try {
        await programJoinMutation({ programId, creationSource: 'LEARNER_ACTION' });
      } catch {
        // Intentionally swallowed — the redirect happens regardless (see comment above).
      } finally {
        setAutoJoinSettled(true);
      }
    };

    void runAutoJoin();
  }, [enableProgramAutoJoin, isMembershipLoading, program?.id, programJoinMutation, membership?.isAllowlisted]);

  return { enableProgramAutoJoin, autoJoinSettled, autoJoinStartedRef, isMembershipLoading, membership };
};
